import { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  AppBar,
} from "@mui/material";
import Header from "../components/Header";
import Produtos from "../components/Produtos";
import Clientes from "../components/Clientes";
import Entradas from "../components/Entradas";
import Financas from "../components/Financas";






// Função para associar Tab a conteúdo
function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ p: 3 }}>{children}</Box> : null;
}

export default function Home() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{minHeight: "100vh", bgcolor: "#f5f5f5", p: 2 }}>
      <Header/>
      <Paper elevation={3} sx={{ width: "100%", borderRadius: 2 }}>
        {/* Tabs */}
        <AppBar position="static" color="default" sx={{ borderRadius: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Finanças" />
            <Tab label="Produtos" />
            <Tab label="Clientes" />
            <Tab label="Entradas" />
          </Tabs>
        </AppBar>

        {/* Conteúdo de cada Tab */}
        <TabPanel value={tabValue} index={0}>
          <Financas />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Produtos />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <Clientes />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <Entradas />
        </TabPanel>
      </Paper>
    </Box>
  );
}
